import { ColorConstants } from '@shared/constants';
import Routes from '../router/routes.constants';

export const UNKNOWN_ERROR = 'UNKNOWN_ERROR';

export const ALERT_MESSAGES_AND_REDIRECT_LINK = {
    NO_ALERT: {
        message: 'NO_ALERT',
    },
    INTEGRATION_NOT_FOUND: {
        message: gettext('This page is only a demo. Integrate your account here to see real data.'),
        url: Routes.INTEGRATIONS,
    },
    INTEGRATION_NOT_FOUND_WORKFLOW_OR_SETTINGS: {
        message: gettext('Integrate your account here.'),
        url: Routes.INTEGRATIONS,
    },
    INVALID_TOKEN_FOR_ACCOUNT: {
        message: gettext('Invalid Token for Account. Click here to reintegrate your account.'),
        url: Routes.INTEGRATIONS,
    },
    CARDS: {
        READ_ONLY_CARDS: gettext('You have read-only access to the cards because it is shared by another user'),
    },
    CONNECTION_PROBLEM: {
        message: gettext('We had a connection problem, click here to retry.'),
    },
    IS_SHARED_CLIENT: {
        message: gettext('You have read-only access to the cards because this client was shared by another user.'),
    },
    IS_SHARED_ACCOUNT: {
        message: gettext('You have read-only access to the cards because this account was shared by another user'),
    },
    GOOGLE_ADS_UNKNOWN_ERROR: {
        message: gettext('An unknown error occurred with this integration'),
    },
    INSUFFICIENT_PERMISSIONS: {
        message: gettext('User does not have any Account for this integration.'),
    },
    GOOGLE_ADS_CUSTOMER_NOT_FOUND: {
        message: gettext('GoogleAds customer not found'),
    },
    GOOGLE_ANALYTICS_UNKNOWN_ERROR: {
        message: gettext('An unknown error occurred with Google Analytics Integration'),
    },
    UNKNOWN_ERROR: {
        message: gettext('An unknown error occurred. Please, contact the support.'),
    },
    NO_ACCOUNT_FOR_THIS_INTEGRATION: {
        message: gettext('We cannot get any account from the integration made.'),
    },
    FACEBOOK_API_ERROR: {
        message: gettext('Error with Facebook Integration. Please, contact the support.'),
    },
    FACEBOOK_API_IS_DOWN: {
        message: gettext('We are experiencing issues with Facebook Services due to Facebook API problems. '
        + 'That may affect Facebook automations and data in Pareto Ads Platform.'),
        url: 'https://developers.facebook.com/status/dashboard/',
        fontColor: ColorConstants['default-black'],
        backgroudColor: ColorConstants['regal-blue-50%'],
    },
};
